import { ReportUserType } from '../report-user.type';

export enum PaymentInstallmentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export interface InstallmentReportRow extends ReportUserType {
  installmentPlanId: number;
  totalAmount: number;
  numberOfInstallments: number;
  firstPaymentDate: Date;
  paymentDayOfMonth: number;
  cancelledAt: Date | null;
  cancelledBy: number | null;
  cancelledReason: string | null;
  installmentNumber: number;
  dueDate: Date;
  amount: number;
  status: PaymentInstallmentStatus;
  userPaymentId: number | null;
  paidAt: Date | null;
}
